import { Routes } from '@angular/router';

import { SubmissionFormComponent } from './submission-form.component';
import { AuthPublicGuard } from '@shared/guards/auth.public.guard';

export const submissionFormRoutes: Routes = [
  {
    path: '',
    component: SubmissionFormComponent,
    canActivate: [AuthPublicGuard]
  }
];
